<div
  class="grid-stack-item-content"
  lhpeElementLoader
  #elementLoader="elementloader"
>
  <div
    class="widget-heading"
    (mousedown)="onMouseDown()"
    (mouseup)="onMouseUp()"
  >
    <div class="title">
      {{ title }}
    </div>
    <div class="options">
      <button
        mat-icon-button
        class="option-button"
        (click)="openWeatherOptions()"
      >
        <svg-icon src="assets/svg/ellipsis.svg"></svg-icon>
      </button>

      <button mat-fab class="option-button">
        <svg-icon
          src="assets/svg/trashcan.svg"
          (click)="delete()"
          [svgStyle]="{
            'width.px': '17',
            'height.px': '17'
          }"
          svgClass="grey"
          viewBox="auto"
        ></svg-icon>
      </button>
    </div>
  </div>
  <div class="widget-content">
    <div class="weather" *ngIf="weather">
      <div *ngIf="is1x2" class="onextwo">
        <div class="icon">
          <img
            src="http://openweathermap.org/img/wn/{{ weather.icon }}@2x.png"
            alt="{{ weather.description }}"
          />
        </div>

        <div class="title">{{ weather.city }}</div>
        <div class="temp">{{ weather.temp | temperature: weather.type }}</div>
        <div class="other-temps">
          <div class="other-temp">
            <strong>Feels like</strong>
            {{ weather.feels_like | temperature: weather.type }}
          </div>
          <div class="other-temp">
            <strong>Minimum</strong>
            {{ weather.temp_min | temperature: weather.type }}
          </div>
          <div class="other-temp">
            <strong>Maximum</strong>
            {{ weather.temp_max | temperature: weather.type }}
          </div>
        </div>
      </div>

      <div *ngIf="is1x1" class="onexone">
        <div class="icon">
          <img
            src="http://openweathermap.org/img/wn/{{ weather.icon }}.png"
            alt="{{ weather.description }}"
          />
        </div>
        <div class="title">{{ weather.city }}</div>
        <div class="temp">{{ weather.temp | temperature: weather.type }}</div>
      </div>

      <div *ngIf="is2x1" class="twoxone">
        <div class="icon">
          <img
            src="http://openweathermap.org/img/wn/{{ weather.icon }}@2x.png"
            alt="{{ weather.description }}"
          />
        </div>
        <div class="weather-info">
          <div class="title">{{ weather.city }}</div>
          <div class="temp">
            {{ weather.temp | temperature: weather.type }}
            <div class="feels-like">
              <strong>Feels like</strong>
              {{ weather.feels_like | temperature: weather.type }}
            </div>
          </div>
          <div class="other-temps">
            <div class="other-temp">
              <strong>Minimum</strong>
              {{ weather.temp_min | temperature: weather.type }}
            </div>
            <div class="other-temp">
              <strong>Maximum</strong>
              {{ weather.temp_max | temperature: weather.type }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
